<template>
  <Modal
    class-name="save-condition-modal"
    v-model="modal"
    title="保存查询条件"
    width="340"
    @on-cancel="oncancel"
  >
    <Form ref="modelFormRef" :model="data" v-if="data" :rules="ruleInline">
      <FormItem prop="name">
        <Input type="text" v-model="data.name" :maxlength="50" placeholder="请输入查询标题">
        </Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button
        size="large"
        type="primary"
        shape="circle"
        style="width: 160px; height: 32px; line-height: 16px; font-size: 12px"
        :loading="loading"
        @click="submit"
        @enter="submit"
        >确定</Button
      >
    </div>
  </Modal>
</template>

<script setup>
import { ref, getCurrentInstance, watch } from 'vue'
const props = defineProps({
  data: Object,
  visible: {
    type: Boolean,
    default: false,
  },
  saveCriteriaMenuUrl: {
    type: String,
    default: 'rest/ezcomp/dict/criteria/menu/submit',
  },
})

const emit = defineEmits(['on-ok', 'on-cancel'])

const modal = ref(false)
const modelFormRef = ref(null)

const ruleInline = ref({
  name: [{ required: true, message: '请输入保存查询标题', trigger: 'change' }],
})

const oncancel = () => {
  emit('on-cancel')
}
watch(
  () => props.visible,
  () => {
    modal.value = props.visible
  },
  { immediate: true }
)

const { proxy } = getCurrentInstance()
const loading = ref(false)
const submit = async () => {
  loading.value = true
  const res = await modelFormRef.value.validate()
  if (!res) {
    loading.value = false
    return false
  }
  proxy.$axios
    .post(props.saveCriteriaMenuUrl, props.data)
    .then((res) => {
      loading.value = false
      if (!proxy.$cfn.ajax1.isOK(res, proxy)) return
      proxy.$Message.success(res.data.msg)
      emit('on-ok')
    })
    .catch(() => {
      loading.value = false
    })
}
</script>
